/* eslint-disable */
// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,add_pb_suffix,ts_nocheck,eslint_disable
// @generated from protobuf file "api/sale/service.proto" (package "rd.api.sale", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { SaleService } from "./service_pb";
import type { CalculatePartialCloseoutTotalsRes } from "./service_pb";
import type { CalculatePartialCloseoutTotalsReq } from "./service_pb";
import type { CloseOutSaleRes } from "./service_pb";
import type { CloseOutSaleReq } from "./service_pb";
import type { RefundDepositRes } from "./service_pb";
import type { RefundDepositReq } from "./service_pb";
import type { UpdateSpecialOrderProductPriceAndCostRes } from "./service_pb";
import type { UpdateSpecialOrderProductPriceAndCostReq } from "./service_pb";
import type { RefundInteracPaymentRes } from "./service_pb";
import type { RefundInteracPaymentReq } from "./service_pb";
import type { UnlinkedReturnsRes } from "./service_pb";
import type { UnlinkedReturnsReq } from "./service_pb";
import type { CalculateReturnTotalsRes } from "./service_pb";
import type { CalculateReturnTotalsReq } from "./service_pb";
import type { UpdateSaleProductReturnedCostRes } from "./service_pb";
import type { UpdateSaleProductReturnedCostReq } from "./service_pb";
import type { UpdateSaleProductReturnedRes } from "./service_pb";
import type { UpdateSaleProductReturnedReq } from "./service_pb";
import type { EmailReturnPDFRes } from "./service_pb";
import type { EmailReturnPDFReq } from "./service_pb";
import type { UpdateReturnDetailsRes } from "./service_pb";
import type { UpdateReturnDetailsReq } from "./service_pb";
import type { GetReturnPDFRes } from "./service_pb";
import type { GetReturnPDFReq } from "./service_pb";
import type { ReturnSaleRes } from "./service_pb";
import type { ReturnSaleReq } from "./service_pb";
import type { GetReturnRes } from "./service_pb";
import type { GetReturnReq } from "./service_pb";
import type { UpdateSaleTypeRes } from "./service_pb";
import type { UpdateSaleTypeReq } from "./service_pb";
import type { CalculateCardSurchargeDisplayInfoRes } from "./service_pb";
import type { CalculateCardSurchargeDisplayInfoReq } from "./service_pb";
import type { CalculateCardSurchargeRes } from "./service_pb";
import type { CalculateCardSurchargeReq } from "./service_pb";
import type { EditSaleDesignatedClerkRes } from "./service_pb";
import type { EditSaleDesignatedClerkReq } from "./service_pb";
import type { EditSaleDiscountDateRes } from "./service_pb";
import type { EditSaleDiscountDateReq } from "./service_pb";
import type { EditSaleDueDateRes } from "./service_pb";
import type { EditSaleDueDateReq } from "./service_pb";
import type { EditSaleDateRes } from "./service_pb";
import type { EditSaleDateReq } from "./service_pb";
import type { GetIsEditingCompletedSaleAllowedRes } from "./service_pb";
import type { GetIsEditingCompletedSaleAllowedReq } from "./service_pb";
import type { VoidCompletedSaleRes } from "./service_pb";
import type { VoidCompletedSaleReq } from "./service_pb";
import type { UpdateUnpaidChargeAccountSaleDateRes } from "./service_pb";
import type { UpdateUnpaidChargeAccountSaleDateReq } from "./service_pb";
import type { DuplicateSaleRes } from "./service_pb";
import type { DuplicateSaleReq } from "./service_pb";
import type { ListCCPRebateReportUploadsRes } from "./service_pb";
import type { ListCCPRebateReportUploadsReq } from "./service_pb";
import type { UpdateSaleProductCostsFromCCPRebatesRes } from "./service_pb";
import type { UpdateSaleProductCostsFromCCPRebatesReq } from "./service_pb";
import type { UpdateSaleProductCostRes } from "./service_pb";
import type { UpdateSaleProductCostReq } from "./service_pb";
import type { UpdateSaleProductAdditionalFeesRes } from "./service_pb";
import type { UpdateSaleProductAdditionalFeesReq } from "./service_pb";
import type { CanEditPriceDuringSaleRes } from "./service_pb";
import type { CanEditPriceDuringSaleReq } from "./service_pb";
import type { SetCardReaderDisplayRes } from "./service_pb";
import type { SetCardReaderDisplayReq } from "./service_pb";
import type { AuthorizeCardPaymentRes } from "./service_pb";
import type { AuthorizeCardPaymentReq } from "./service_pb";
import type { GetSalePDFRes } from "./service_pb";
import type { GetSalePDFReq } from "./service_pb";
import type { EmailSalePDFRes } from "./service_pb";
import type { EmailSalePDFReq } from "./service_pb";
import type { UpdateSoldSaleDetailsRes } from "./service_pb";
import type { UpdateSoldSaleDetailsReq } from "./service_pb";
import type { UpdateSoldSaleProductRes } from "./service_pb";
import type { UpdateSoldSaleProductReq } from "./service_pb";
import type { GetCartPricesRes } from "./service_pb";
import type { GetCartPricesReq } from "./service_pb";
import type { SyncCartPricesRes } from "./service_pb";
import type { SyncCartPricesReq } from "./service_pb";
import type { UpsertSaleV3Res } from "./service_pb";
import type { UpsertSaleV3Req } from "./service_pb";
import type { GetScannedSaleRes } from "./service_pb";
import type { GetScannedSaleReq } from "./service_pb";
import type { GetSaleRes } from "./service_pb";
import type { GetSaleReq } from "./service_pb";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { GetSaleCountsByStatusRes } from "./service_pb";
import type { GetSaleCountsByStatusReq } from "./service_pb";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service rd.api.sale.SaleService
 */
export interface ISaleServiceClient {
    /**
     * @generated from protobuf rpc: GetSaleCountsByStatus
     */
    getSaleCountsByStatus(input: GetSaleCountsByStatusReq, options?: RpcOptions): UnaryCall<GetSaleCountsByStatusReq, GetSaleCountsByStatusRes>;
    /**
     * @generated from protobuf rpc: GetSale
     */
    getSale(input: GetSaleReq, options?: RpcOptions): UnaryCall<GetSaleReq, GetSaleRes>;
    /**
     * @generated from protobuf rpc: GetScannedSale
     */
    getScannedSale(input: GetScannedSaleReq, options?: RpcOptions): UnaryCall<GetScannedSaleReq, GetScannedSaleRes>;
    /**
     * @generated from protobuf rpc: UpsertSaleV3
     */
    upsertSaleV3(input: UpsertSaleV3Req, options?: RpcOptions): UnaryCall<UpsertSaleV3Req, UpsertSaleV3Res>;
    /**
     * @generated from protobuf rpc: SyncCartPrices
     */
    syncCartPrices(input: SyncCartPricesReq, options?: RpcOptions): UnaryCall<SyncCartPricesReq, SyncCartPricesRes>;
    /**
     * @generated from protobuf rpc: GetCartPrices
     */
    getCartPrices(input: GetCartPricesReq, options?: RpcOptions): UnaryCall<GetCartPricesReq, GetCartPricesRes>;
    /**
     * @generated from protobuf rpc: UpdateSoldSaleProduct
     */
    updateSoldSaleProduct(input: UpdateSoldSaleProductReq, options?: RpcOptions): UnaryCall<UpdateSoldSaleProductReq, UpdateSoldSaleProductRes>;
    /**
     * @generated from protobuf rpc: UpdateSoldSaleDetails
     */
    updateSoldSaleDetails(input: UpdateSoldSaleDetailsReq, options?: RpcOptions): UnaryCall<UpdateSoldSaleDetailsReq, UpdateSoldSaleDetailsRes>;
    /**
     * @generated from protobuf rpc: EmailSalePDF
     */
    emailSalePDF(input: EmailSalePDFReq, options?: RpcOptions): UnaryCall<EmailSalePDFReq, EmailSalePDFRes>;
    /**
     * @generated from protobuf rpc: GetSalePDF
     */
    getSalePDF(input: GetSalePDFReq, options?: RpcOptions): UnaryCall<GetSalePDFReq, GetSalePDFRes>;
    /**
     * @generated from protobuf rpc: AuthorizeCardPayment
     */
    authorizeCardPayment(input: AuthorizeCardPaymentReq, options?: RpcOptions): UnaryCall<AuthorizeCardPaymentReq, AuthorizeCardPaymentRes>;
    /**
     * @generated from protobuf rpc: SetCardReaderDisplay
     */
    setCardReaderDisplay(input: SetCardReaderDisplayReq, options?: RpcOptions): UnaryCall<SetCardReaderDisplayReq, SetCardReaderDisplayRes>;
    /**
     * @generated from protobuf rpc: CanEditPriceDuringSale
     */
    canEditPriceDuringSale(input: CanEditPriceDuringSaleReq, options?: RpcOptions): UnaryCall<CanEditPriceDuringSaleReq, CanEditPriceDuringSaleRes>;
    /**
     * @generated from protobuf rpc: UpdateSaleProductAdditionalFees
     */
    updateSaleProductAdditionalFees(input: UpdateSaleProductAdditionalFeesReq, options?: RpcOptions): UnaryCall<UpdateSaleProductAdditionalFeesReq, UpdateSaleProductAdditionalFeesRes>;
    /**
     * @generated from protobuf rpc: UpdateSaleProductCost
     */
    updateSaleProductCost(input: UpdateSaleProductCostReq, options?: RpcOptions): UnaryCall<UpdateSaleProductCostReq, UpdateSaleProductCostRes>;
    /**
     * @generated from protobuf rpc: UpdateSaleProductCostsFromCCPRebates
     */
    updateSaleProductCostsFromCCPRebates(input: UpdateSaleProductCostsFromCCPRebatesReq, options?: RpcOptions): UnaryCall<UpdateSaleProductCostsFromCCPRebatesReq, UpdateSaleProductCostsFromCCPRebatesRes>;
    /**
     * @generated from protobuf rpc: ListCCPRebateReportUploads
     */
    listCCPRebateReportUploads(input: ListCCPRebateReportUploadsReq, options?: RpcOptions): UnaryCall<ListCCPRebateReportUploadsReq, ListCCPRebateReportUploadsRes>;
    /**
     * @generated from protobuf rpc: DuplicateSale
     */
    duplicateSale(input: DuplicateSaleReq, options?: RpcOptions): UnaryCall<DuplicateSaleReq, DuplicateSaleRes>;
    /**
     * @generated from protobuf rpc: UpdateUnpaidChargeAccountSaleDate
     */
    updateUnpaidChargeAccountSaleDate(input: UpdateUnpaidChargeAccountSaleDateReq, options?: RpcOptions): UnaryCall<UpdateUnpaidChargeAccountSaleDateReq, UpdateUnpaidChargeAccountSaleDateRes>;
    /**
     * @generated from protobuf rpc: VoidCompletedSale
     */
    voidCompletedSale(input: VoidCompletedSaleReq, options?: RpcOptions): UnaryCall<VoidCompletedSaleReq, VoidCompletedSaleRes>;
    /**
     * @generated from protobuf rpc: GetIsEditingCompletedSaleAllowed
     */
    getIsEditingCompletedSaleAllowed(input: GetIsEditingCompletedSaleAllowedReq, options?: RpcOptions): UnaryCall<GetIsEditingCompletedSaleAllowedReq, GetIsEditingCompletedSaleAllowedRes>;
    /**
     * @generated from protobuf rpc: EditSaleDate
     */
    editSaleDate(input: EditSaleDateReq, options?: RpcOptions): UnaryCall<EditSaleDateReq, EditSaleDateRes>;
    /**
     * @generated from protobuf rpc: EditSaleDueDate
     */
    editSaleDueDate(input: EditSaleDueDateReq, options?: RpcOptions): UnaryCall<EditSaleDueDateReq, EditSaleDueDateRes>;
    /**
     * @generated from protobuf rpc: EditSaleDiscountDate
     */
    editSaleDiscountDate(input: EditSaleDiscountDateReq, options?: RpcOptions): UnaryCall<EditSaleDiscountDateReq, EditSaleDiscountDateRes>;
    /**
     * @generated from protobuf rpc: EditSaleDesignatedClerk
     */
    editSaleDesignatedClerk(input: EditSaleDesignatedClerkReq, options?: RpcOptions): UnaryCall<EditSaleDesignatedClerkReq, EditSaleDesignatedClerkRes>;
    /**
     * @generated from protobuf rpc: CalculateCardSurcharge
     */
    calculateCardSurcharge(input: CalculateCardSurchargeReq, options?: RpcOptions): UnaryCall<CalculateCardSurchargeReq, CalculateCardSurchargeRes>;
    /**
     * @generated from protobuf rpc: CalculateCardSurchargeDisplayInfo
     */
    calculateCardSurchargeDisplayInfo(input: CalculateCardSurchargeDisplayInfoReq, options?: RpcOptions): UnaryCall<CalculateCardSurchargeDisplayInfoReq, CalculateCardSurchargeDisplayInfoRes>;
    /**
     * @generated from protobuf rpc: UpdateSaleType
     */
    updateSaleType(input: UpdateSaleTypeReq, options?: RpcOptions): UnaryCall<UpdateSaleTypeReq, UpdateSaleTypeRes>;
    /**
     * Returns
     *
     * @generated from protobuf rpc: GetReturn
     */
    getReturn(input: GetReturnReq, options?: RpcOptions): UnaryCall<GetReturnReq, GetReturnRes>;
    /**
     * @generated from protobuf rpc: ReturnSale
     */
    returnSale(input: ReturnSaleReq, options?: RpcOptions): UnaryCall<ReturnSaleReq, ReturnSaleRes>;
    /**
     * @generated from protobuf rpc: GetReturnPDF
     */
    getReturnPDF(input: GetReturnPDFReq, options?: RpcOptions): UnaryCall<GetReturnPDFReq, GetReturnPDFRes>;
    /**
     * @generated from protobuf rpc: UpdateReturnDetails
     */
    updateReturnDetails(input: UpdateReturnDetailsReq, options?: RpcOptions): UnaryCall<UpdateReturnDetailsReq, UpdateReturnDetailsRes>;
    /**
     * @generated from protobuf rpc: EmailReturnPDF
     */
    emailReturnPDF(input: EmailReturnPDFReq, options?: RpcOptions): UnaryCall<EmailReturnPDFReq, EmailReturnPDFRes>;
    /**
     * @generated from protobuf rpc: UpdateSaleProductReturned
     */
    updateSaleProductReturned(input: UpdateSaleProductReturnedReq, options?: RpcOptions): UnaryCall<UpdateSaleProductReturnedReq, UpdateSaleProductReturnedRes>;
    /**
     * @generated from protobuf rpc: UpdateSaleProductReturnedCost
     */
    updateSaleProductReturnedCost(input: UpdateSaleProductReturnedCostReq, options?: RpcOptions): UnaryCall<UpdateSaleProductReturnedCostReq, UpdateSaleProductReturnedCostRes>;
    /**
     * @generated from protobuf rpc: CalculateReturnTotals
     */
    calculateReturnTotals(input: CalculateReturnTotalsReq, options?: RpcOptions): UnaryCall<CalculateReturnTotalsReq, CalculateReturnTotalsRes>;
    /**
     * @generated from protobuf rpc: UnlinkedReturns
     */
    unlinkedReturns(input: UnlinkedReturnsReq, options?: RpcOptions): UnaryCall<UnlinkedReturnsReq, UnlinkedReturnsRes>;
    /**
     * @generated from protobuf rpc: RefundInteracPayment
     */
    refundInteracPayment(input: RefundInteracPaymentReq, options?: RpcOptions): UnaryCall<RefundInteracPaymentReq, RefundInteracPaymentRes>;
    /**
     * Special orders
     *
     * @generated from protobuf rpc: UpdateSpecialOrderProductPriceAndCost
     */
    updateSpecialOrderProductPriceAndCost(input: UpdateSpecialOrderProductPriceAndCostReq, options?: RpcOptions): UnaryCall<UpdateSpecialOrderProductPriceAndCostReq, UpdateSpecialOrderProductPriceAndCostRes>;
    /**
     * @generated from protobuf rpc: RefundDeposit
     */
    refundDeposit(input: RefundDepositReq, options?: RpcOptions): UnaryCall<RefundDepositReq, RefundDepositRes>;
    /**
     * @generated from protobuf rpc: CloseOutSale
     */
    closeOutSale(input: CloseOutSaleReq, options?: RpcOptions): UnaryCall<CloseOutSaleReq, CloseOutSaleRes>;
    /**
     * @generated from protobuf rpc: CalculatePartialCloseoutTotals
     */
    calculatePartialCloseoutTotals(input: CalculatePartialCloseoutTotalsReq, options?: RpcOptions): UnaryCall<CalculatePartialCloseoutTotalsReq, CalculatePartialCloseoutTotalsRes>;
}
/**
 * @generated from protobuf service rd.api.sale.SaleService
 */
export class SaleServiceClient implements ISaleServiceClient, ServiceInfo {
    typeName = SaleService.typeName;
    methods = SaleService.methods;
    options = SaleService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: GetSaleCountsByStatus
     */
    getSaleCountsByStatus(input: GetSaleCountsByStatusReq, options?: RpcOptions): UnaryCall<GetSaleCountsByStatusReq, GetSaleCountsByStatusRes> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetSaleCountsByStatusReq, GetSaleCountsByStatusRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetSale
     */
    getSale(input: GetSaleReq, options?: RpcOptions): UnaryCall<GetSaleReq, GetSaleRes> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetSaleReq, GetSaleRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetScannedSale
     */
    getScannedSale(input: GetScannedSaleReq, options?: RpcOptions): UnaryCall<GetScannedSaleReq, GetScannedSaleRes> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetScannedSaleReq, GetScannedSaleRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpsertSaleV3
     */
    upsertSaleV3(input: UpsertSaleV3Req, options?: RpcOptions): UnaryCall<UpsertSaleV3Req, UpsertSaleV3Res> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpsertSaleV3Req, UpsertSaleV3Res>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SyncCartPrices
     */
    syncCartPrices(input: SyncCartPricesReq, options?: RpcOptions): UnaryCall<SyncCartPricesReq, SyncCartPricesRes> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<SyncCartPricesReq, SyncCartPricesRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetCartPrices
     */
    getCartPrices(input: GetCartPricesReq, options?: RpcOptions): UnaryCall<GetCartPricesReq, GetCartPricesRes> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetCartPricesReq, GetCartPricesRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateSoldSaleProduct
     */
    updateSoldSaleProduct(input: UpdateSoldSaleProductReq, options?: RpcOptions): UnaryCall<UpdateSoldSaleProductReq, UpdateSoldSaleProductRes> {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateSoldSaleProductReq, UpdateSoldSaleProductRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateSoldSaleDetails
     */
    updateSoldSaleDetails(input: UpdateSoldSaleDetailsReq, options?: RpcOptions): UnaryCall<UpdateSoldSaleDetailsReq, UpdateSoldSaleDetailsRes> {
        const method = this.methods[7], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateSoldSaleDetailsReq, UpdateSoldSaleDetailsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: EmailSalePDF
     */
    emailSalePDF(input: EmailSalePDFReq, options?: RpcOptions): UnaryCall<EmailSalePDFReq, EmailSalePDFRes> {
        const method = this.methods[8], opt = this._transport.mergeOptions(options);
        return stackIntercept<EmailSalePDFReq, EmailSalePDFRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetSalePDF
     */
    getSalePDF(input: GetSalePDFReq, options?: RpcOptions): UnaryCall<GetSalePDFReq, GetSalePDFRes> {
        const method = this.methods[9], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetSalePDFReq, GetSalePDFRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: AuthorizeCardPayment
     */
    authorizeCardPayment(input: AuthorizeCardPaymentReq, options?: RpcOptions): UnaryCall<AuthorizeCardPaymentReq, AuthorizeCardPaymentRes> {
        const method = this.methods[10], opt = this._transport.mergeOptions(options);
        return stackIntercept<AuthorizeCardPaymentReq, AuthorizeCardPaymentRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SetCardReaderDisplay
     */
    setCardReaderDisplay(input: SetCardReaderDisplayReq, options?: RpcOptions): UnaryCall<SetCardReaderDisplayReq, SetCardReaderDisplayRes> {
        const method = this.methods[11], opt = this._transport.mergeOptions(options);
        return stackIntercept<SetCardReaderDisplayReq, SetCardReaderDisplayRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CanEditPriceDuringSale
     */
    canEditPriceDuringSale(input: CanEditPriceDuringSaleReq, options?: RpcOptions): UnaryCall<CanEditPriceDuringSaleReq, CanEditPriceDuringSaleRes> {
        const method = this.methods[12], opt = this._transport.mergeOptions(options);
        return stackIntercept<CanEditPriceDuringSaleReq, CanEditPriceDuringSaleRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateSaleProductAdditionalFees
     */
    updateSaleProductAdditionalFees(input: UpdateSaleProductAdditionalFeesReq, options?: RpcOptions): UnaryCall<UpdateSaleProductAdditionalFeesReq, UpdateSaleProductAdditionalFeesRes> {
        const method = this.methods[13], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateSaleProductAdditionalFeesReq, UpdateSaleProductAdditionalFeesRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateSaleProductCost
     */
    updateSaleProductCost(input: UpdateSaleProductCostReq, options?: RpcOptions): UnaryCall<UpdateSaleProductCostReq, UpdateSaleProductCostRes> {
        const method = this.methods[14], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateSaleProductCostReq, UpdateSaleProductCostRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateSaleProductCostsFromCCPRebates
     */
    updateSaleProductCostsFromCCPRebates(input: UpdateSaleProductCostsFromCCPRebatesReq, options?: RpcOptions): UnaryCall<UpdateSaleProductCostsFromCCPRebatesReq, UpdateSaleProductCostsFromCCPRebatesRes> {
        const method = this.methods[15], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateSaleProductCostsFromCCPRebatesReq, UpdateSaleProductCostsFromCCPRebatesRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListCCPRebateReportUploads
     */
    listCCPRebateReportUploads(input: ListCCPRebateReportUploadsReq, options?: RpcOptions): UnaryCall<ListCCPRebateReportUploadsReq, ListCCPRebateReportUploadsRes> {
        const method = this.methods[16], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListCCPRebateReportUploadsReq, ListCCPRebateReportUploadsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DuplicateSale
     */
    duplicateSale(input: DuplicateSaleReq, options?: RpcOptions): UnaryCall<DuplicateSaleReq, DuplicateSaleRes> {
        const method = this.methods[17], opt = this._transport.mergeOptions(options);
        return stackIntercept<DuplicateSaleReq, DuplicateSaleRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateUnpaidChargeAccountSaleDate
     */
    updateUnpaidChargeAccountSaleDate(input: UpdateUnpaidChargeAccountSaleDateReq, options?: RpcOptions): UnaryCall<UpdateUnpaidChargeAccountSaleDateReq, UpdateUnpaidChargeAccountSaleDateRes> {
        const method = this.methods[18], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateUnpaidChargeAccountSaleDateReq, UpdateUnpaidChargeAccountSaleDateRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: VoidCompletedSale
     */
    voidCompletedSale(input: VoidCompletedSaleReq, options?: RpcOptions): UnaryCall<VoidCompletedSaleReq, VoidCompletedSaleRes> {
        const method = this.methods[19], opt = this._transport.mergeOptions(options);
        return stackIntercept<VoidCompletedSaleReq, VoidCompletedSaleRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetIsEditingCompletedSaleAllowed
     */
    getIsEditingCompletedSaleAllowed(input: GetIsEditingCompletedSaleAllowedReq, options?: RpcOptions): UnaryCall<GetIsEditingCompletedSaleAllowedReq, GetIsEditingCompletedSaleAllowedRes> {
        const method = this.methods[20], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetIsEditingCompletedSaleAllowedReq, GetIsEditingCompletedSaleAllowedRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: EditSaleDate
     */
    editSaleDate(input: EditSaleDateReq, options?: RpcOptions): UnaryCall<EditSaleDateReq, EditSaleDateRes> {
        const method = this.methods[21], opt = this._transport.mergeOptions(options);
        return stackIntercept<EditSaleDateReq, EditSaleDateRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: EditSaleDueDate
     */
    editSaleDueDate(input: EditSaleDueDateReq, options?: RpcOptions): UnaryCall<EditSaleDueDateReq, EditSaleDueDateRes> {
        const method = this.methods[22], opt = this._transport.mergeOptions(options);
        return stackIntercept<EditSaleDueDateReq, EditSaleDueDateRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: EditSaleDiscountDate
     */
    editSaleDiscountDate(input: EditSaleDiscountDateReq, options?: RpcOptions): UnaryCall<EditSaleDiscountDateReq, EditSaleDiscountDateRes> {
        const method = this.methods[23], opt = this._transport.mergeOptions(options);
        return stackIntercept<EditSaleDiscountDateReq, EditSaleDiscountDateRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: EditSaleDesignatedClerk
     */
    editSaleDesignatedClerk(input: EditSaleDesignatedClerkReq, options?: RpcOptions): UnaryCall<EditSaleDesignatedClerkReq, EditSaleDesignatedClerkRes> {
        const method = this.methods[24], opt = this._transport.mergeOptions(options);
        return stackIntercept<EditSaleDesignatedClerkReq, EditSaleDesignatedClerkRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CalculateCardSurcharge
     */
    calculateCardSurcharge(input: CalculateCardSurchargeReq, options?: RpcOptions): UnaryCall<CalculateCardSurchargeReq, CalculateCardSurchargeRes> {
        const method = this.methods[25], opt = this._transport.mergeOptions(options);
        return stackIntercept<CalculateCardSurchargeReq, CalculateCardSurchargeRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CalculateCardSurchargeDisplayInfo
     */
    calculateCardSurchargeDisplayInfo(input: CalculateCardSurchargeDisplayInfoReq, options?: RpcOptions): UnaryCall<CalculateCardSurchargeDisplayInfoReq, CalculateCardSurchargeDisplayInfoRes> {
        const method = this.methods[26], opt = this._transport.mergeOptions(options);
        return stackIntercept<CalculateCardSurchargeDisplayInfoReq, CalculateCardSurchargeDisplayInfoRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateSaleType
     */
    updateSaleType(input: UpdateSaleTypeReq, options?: RpcOptions): UnaryCall<UpdateSaleTypeReq, UpdateSaleTypeRes> {
        const method = this.methods[27], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateSaleTypeReq, UpdateSaleTypeRes>("unary", this._transport, method, opt, input);
    }
    /**
     * Returns
     *
     * @generated from protobuf rpc: GetReturn
     */
    getReturn(input: GetReturnReq, options?: RpcOptions): UnaryCall<GetReturnReq, GetReturnRes> {
        const method = this.methods[28], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetReturnReq, GetReturnRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ReturnSale
     */
    returnSale(input: ReturnSaleReq, options?: RpcOptions): UnaryCall<ReturnSaleReq, ReturnSaleRes> {
        const method = this.methods[29], opt = this._transport.mergeOptions(options);
        return stackIntercept<ReturnSaleReq, ReturnSaleRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetReturnPDF
     */
    getReturnPDF(input: GetReturnPDFReq, options?: RpcOptions): UnaryCall<GetReturnPDFReq, GetReturnPDFRes> {
        const method = this.methods[30], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetReturnPDFReq, GetReturnPDFRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateReturnDetails
     */
    updateReturnDetails(input: UpdateReturnDetailsReq, options?: RpcOptions): UnaryCall<UpdateReturnDetailsReq, UpdateReturnDetailsRes> {
        const method = this.methods[31], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateReturnDetailsReq, UpdateReturnDetailsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: EmailReturnPDF
     */
    emailReturnPDF(input: EmailReturnPDFReq, options?: RpcOptions): UnaryCall<EmailReturnPDFReq, EmailReturnPDFRes> {
        const method = this.methods[32], opt = this._transport.mergeOptions(options);
        return stackIntercept<EmailReturnPDFReq, EmailReturnPDFRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateSaleProductReturned
     */
    updateSaleProductReturned(input: UpdateSaleProductReturnedReq, options?: RpcOptions): UnaryCall<UpdateSaleProductReturnedReq, UpdateSaleProductReturnedRes> {
        const method = this.methods[33], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateSaleProductReturnedReq, UpdateSaleProductReturnedRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateSaleProductReturnedCost
     */
    updateSaleProductReturnedCost(input: UpdateSaleProductReturnedCostReq, options?: RpcOptions): UnaryCall<UpdateSaleProductReturnedCostReq, UpdateSaleProductReturnedCostRes> {
        const method = this.methods[34], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateSaleProductReturnedCostReq, UpdateSaleProductReturnedCostRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CalculateReturnTotals
     */
    calculateReturnTotals(input: CalculateReturnTotalsReq, options?: RpcOptions): UnaryCall<CalculateReturnTotalsReq, CalculateReturnTotalsRes> {
        const method = this.methods[35], opt = this._transport.mergeOptions(options);
        return stackIntercept<CalculateReturnTotalsReq, CalculateReturnTotalsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UnlinkedReturns
     */
    unlinkedReturns(input: UnlinkedReturnsReq, options?: RpcOptions): UnaryCall<UnlinkedReturnsReq, UnlinkedReturnsRes> {
        const method = this.methods[36], opt = this._transport.mergeOptions(options);
        return stackIntercept<UnlinkedReturnsReq, UnlinkedReturnsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: RefundInteracPayment
     */
    refundInteracPayment(input: RefundInteracPaymentReq, options?: RpcOptions): UnaryCall<RefundInteracPaymentReq, RefundInteracPaymentRes> {
        const method = this.methods[37], opt = this._transport.mergeOptions(options);
        return stackIntercept<RefundInteracPaymentReq, RefundInteracPaymentRes>("unary", this._transport, method, opt, input);
    }
    /**
     * Special orders
     *
     * @generated from protobuf rpc: UpdateSpecialOrderProductPriceAndCost
     */
    updateSpecialOrderProductPriceAndCost(input: UpdateSpecialOrderProductPriceAndCostReq, options?: RpcOptions): UnaryCall<UpdateSpecialOrderProductPriceAndCostReq, UpdateSpecialOrderProductPriceAndCostRes> {
        const method = this.methods[38], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateSpecialOrderProductPriceAndCostReq, UpdateSpecialOrderProductPriceAndCostRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: RefundDeposit
     */
    refundDeposit(input: RefundDepositReq, options?: RpcOptions): UnaryCall<RefundDepositReq, RefundDepositRes> {
        const method = this.methods[39], opt = this._transport.mergeOptions(options);
        return stackIntercept<RefundDepositReq, RefundDepositRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CloseOutSale
     */
    closeOutSale(input: CloseOutSaleReq, options?: RpcOptions): UnaryCall<CloseOutSaleReq, CloseOutSaleRes> {
        const method = this.methods[40], opt = this._transport.mergeOptions(options);
        return stackIntercept<CloseOutSaleReq, CloseOutSaleRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CalculatePartialCloseoutTotals
     */
    calculatePartialCloseoutTotals(input: CalculatePartialCloseoutTotalsReq, options?: RpcOptions): UnaryCall<CalculatePartialCloseoutTotalsReq, CalculatePartialCloseoutTotalsRes> {
        const method = this.methods[41], opt = this._transport.mergeOptions(options);
        return stackIntercept<CalculatePartialCloseoutTotalsReq, CalculatePartialCloseoutTotalsRes>("unary", this._transport, method, opt, input);
    }
}
